module.exports = __webpack_public_path__ + "stylesheets/section-different-devices_85c76bdad096f980de4c7e302feccd64.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/sections/section-different-devices.less
// module id = LxjB
// module chunks = 118